import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Registration } from 'src/app/models/registration';

@Component({
  selector: 'pla-inline-plate-viewer-link',
  templateUrl: './inline-plate-viewer-link.component.html',
  styleUrls: ['./inline-plate-viewer-link.component.scss']
})
export class InlinePlateViewerLinkComponent implements OnInit {

  @Input() public plate: Registration;
  @Input() public iconOnly: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public OpenPlateViewerWithPlate(): void {
    if (this.plate == undefined) return;
    var plateToShow = this.plate.formattedRegistration;
    if (plateToShow === undefined || plateToShow === null || plateToShow === '') {
      plateToShow = this.plate.registration;
    }
    this.router.navigate([`/plate-viewer/plate/${plateToShow}`]);
  }

}
